<template>
  <div class="provider-page">
    <provider-sidebar></provider-sidebar>
    <provider-header></provider-header>
    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <div class="row">
          <div class="d-flex justify-content-between align-items-center flex-wrap mb-4">
            <h5>Security Settings</h5>
          </div>
        </div>
        <!-- Security Settings -->
        <div class="row">
          <div class="col-xl-4 col-md-4 d-flex mb-3">
            <div class="linked-item flex-fill">
              <div class="linked-wrap">
                <div class="linked-acc">
                  <span class="link-icon rounded-circle">
                    <i class="ti ti-lock"></i>
                  </span>
                  <div class="linked-info">
                    <h6 class="fs-16">Password</h6>
                    <p class="text-gray fs-12">
                      Last Changed :
                      <span class="text-dark fs-12">22 Sep 2023, 10:30:55 AM</span>
                    </p>
                  </div>
                </div>
                <div class="linked-action">
                  <button
                    class="btn btn-dark btn-sm"
                    data-bs-toggle="modal"
                    data-bs-target="#change-password"
                  >
                    Change Password
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-4 d-flex mb-3">
            <div class="linked-item flex-fill">
              <div class="linked-wrap">
                <div class="linked-acc">
                  <span class="link-icon rounded-circle">
                    <i class="ti ti-fingerprint-scan"></i>
                  </span>
                  <div class="linked-info row align-items-center">
                    <div class="col-md-9">
                      <h6 class="fs-16">Two Factor</h6>
                      <p class="text-gray fs-12 text-truncate">
                        Strengthens security with an extra step.
                      </p>
                    </div>
                    <div class="col-md-3">
                      <div
                        class="d-flex align-items-center justify-content-end form-check form-switch mb-3"
                      >
                        <input type="checkbox" id="status-two" class="form-check-input" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="linked-action">
                  <button class="btn btn-dark btn-sm">Disable</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-4 d-flex mb-3">
            <div class="linked-item flex-fill">
              <div class="linked-wrap">
                <div class="linked-acc">
                  <span class="link-icon rounded-circle">
                    <i class="ti ti-device-mobile"></i>
                  </span>
                  <div class="linked-info row align-items-center">
                    <div class="col-md-9">
                      <h6 class="fs-16 text-truncate">Phone Number Verification</h6>
                      <p class="text-gray fs-12 text-truncate">
                        Verified Mobile Number :
                        <span class="text-dark fs-12"> +99264710583</span>
                      </p>
                    </div>
                    <div class="col-md-3">
                      <div class="d-flex justify-content-end">
                        <span
                          ><i class="ti ti-circle-check-filled text-success"></i
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="linked-action">
                  <button
                    class="btn btn-dark btn-sm"
                    data-bs-toggle="modal"
                    data-bs-target="#change-phone-number"
                  >
                    Change
                  </button>
                  <button class="btn btn-light btn-sm">Remove</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-4 d-flex mb-3">
            <div class="linked-item flex-fill">
              <div class="linked-wrap">
                <div class="linked-acc">
                  <span class="link-icon rounded-circle">
                    <i class="ti ti-mail"></i>
                  </span>
                  <div class="linked-info row align-items-center">
                    <div class="col-md-9">
                      <h6 class="fs-16 text-truncate">Email Verification</h6>
                      <p class="text-gray fs-12 text-truncate">
                        Verified Email :<span class="text-dark fs-12">
                          info@example.com</span
                        >
                      </p>
                    </div>
                    <div class="col-md-3">
                      <div class="d-flex justify-content-end">
                        <span
                          ><i class="ti ti-circle-check-filled text-success"></i
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="linked-action">
                  <button
                    class="btn btn-dark btn-sm"
                    data-bs-toggle="modal"
                    data-bs-target="#change-email"
                  >
                    Change
                  </button>
                  <button class="btn btn-light btn-sm">Remove</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-4 d-flex mb-3">
            <div class="linked-item flex-fill">
              <div class="linked-wrap">
                <div class="linked-acc">
                  <span class="link-icon rounded-circle">
                    <i class="ti ti-device-imac"></i>
                  </span>
                  <div class="linked-info row align-items-center">
                    <div class="col-md-9">
                      <h6 class="fs-16 text-truncate">Device Management</h6>
                      <p class="text-gray fs-12 text-truncate">
                        Last Changed :<span class="text-dark fs-12">
                          22 Jul 2024, 10:30:55 AM</span
                        >
                      </p>
                    </div>
                    <div class="col-md-3">
                      <div class="d-flex justify-content-end">
                        <span
                          ><i class="ti ti-circle-check-filled text-success"></i
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="linked-action">
                  <router-link
                    to="/provider-settings/provider-device-management"
                    class="btn btn-dark btn-sm"
                    >Manage</router-link
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-4 d-flex mb-3">
            <div class="linked-item flex-fill">
              <div class="linked-wrap">
                <div class="linked-acc">
                  <span class="link-icon rounded-circle">
                    <i class="ti ti-user-edit"></i>
                  </span>
                  <div class="linked-info row align-items-center">
                    <div class="col-md-9">
                      <h6 class="fs-16 text-truncate">Account Activity</h6>
                      <p class="text-gray fs-12 text-truncate">
                        Last Changed :<span class="text-dark fs-12">
                          22 Jul 2024, 10:30:55 AM</span
                        >
                      </p>
                    </div>
                    <div class="col-md-3">
                      <div class="d-flex justify-content-end">
                        <span
                          ><i class="ti ti-circle-check-filled text-success"></i
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="linked-action">
                  <router-link to="/provider-settings/provider-login-activity" class="btn btn-dark btn-sm"
                    >Manage</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Security Settings -->
      </div>
    </div>
    <!-- /Page Wrapper -->
    <provider-security-settings-modal></provider-security-settings-modal>
  </div>
</template>
